module.exports = "/_next/static/images/slashing-b61f119110566e44644908272398ac6a.svg";